import { useDisabled } from './helpers.js'
import React from 'react'
import View from './view.js'

export default function Logic(props) {
  let disabled = useDisabled(props)
  return <View {...props} disabled={disabled} />
}
